import { render, staticRenderFns } from "./WorkflowMinimap.vue?vue&type=template&id=40041f74&scoped=true&"
import script from "./WorkflowMinimap.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkflowMinimap.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WorkflowMinimap.vue?vue&type=style&index=0&id=40041f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40041f74",
  null
  
)

export default component.exports